import {PlusOutlined,} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import {Button, Form, Spin, Table, Tabs, Tag,} from "antd";
import {useNavigate} from "react-router-dom";
import axiosInstance from "../../../../../variables/api/axiosInstance";
import {LOGGED_USER, TOKEN} from "../../../../../variables/constants";
import {formatCurrency, formatFrenchDate, getInitiator, isConnectedUser} from "../../../../../variables/functions";
import OrderModal from "../../../components/modals/OrderModal";
import SinglePageLayout from "../../../../../layout/SinglePageLayout";
import PaymentConfirmationModal from "../../../components/modals/PaymentConfirmationModal";
import {validateWithComment} from "../../../../../hooks/useHooks";
import {toast} from "react-toastify";

const AgenceCommande = () => {
    const [orderModalOpen, setOrderModalOpen] = useState(false);
    const [commandes, setCommandes] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingOrders, setLoadingOrders] = useState(false);
    const [updateCommentaire, setUpdateCommentaire] = useState("");
    const [selectedOrder, setSelectedOrder] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const [statutCommande, setStatutCommande] = useState();
    const [lotA, setLotA] = useState();
    const [editingKey, setEditingKey] = useState("");


    const navigate = useNavigate()
    const handleCancel = () => setModalVisible(false);
    const typePaiement = {
        CHEQUE: "CHEQUE",
        ESPECE: "ESPECE",
        MOBILE_MONEY: "MOBILE MONEY",
    };

    const [selectedPaymentType, setSelectedPaymentType] = useState(
        typePaiement.ESPECE,
    );
    const onSubmitCommandeAttestation = () => {
        setReload((prevState) => !prevState)
    };
    let paiement = typePaiement.CHEQUE;
    console.log(paiement);
    console.log(selectedPaymentType);
    const [reload, setReload] = useState(false);
    console.log(commandes);
    const getTagColor = (statutCommande) => {
        switch (statutCommande) {
            case "INITIE":
                return "blue";
            case "VALIDE":
                return "green";
            case "AUTORISE":
                return "gold";
            case "CONFIRME":
                return "purple";
            case "DELIVRE":
                return "cyan";
            case "RECEPTIONNE":
                return "volcano";
            default:
                return "default";
        }
    };
    useEffect(() => {
        axiosInstance
            .get(`/api/bon-commande`)
            .then((res) => {
                setCommandes(res.data.reverse());
                setLoadingOrders(false);
            })
            .catch(() => setLoadingOrders(false));

        axiosInstance
            .get(`/api/categorie`)
            .then((res) => setCategories(res.data))
            .catch(console.error);
    }, [TOKEN, reload]);
    console.log(LOGGED_USER)
    console.log(commandes)
    console.log(getInitiator(commandes[0]?.actionsSurCommande))
    const columns = [
        {
            title: "Numero de commande",
            dataIndex: "numero",
            key: "code",
            render: (_, record) => (<>{record?.codeId} </>),
        },
        {
            title: "Initiée par",
            dataIndex: "initiateur",
            key: "initiateur",
            editable: false,
            render: (_, record) => (
                <>
                    {
                        isConnectedUser(record?.actionsSurCommande) ? (
                            <>
                                Vous
                            </>
                        ) : (
                            <>
                                {
                                    getInitiator(record?.actionsSurCommande) === null ? "-" : (
                                        getInitiator(record?.actionsSurCommande)?.nom === null ? "-" : getInitiator(record?.actionsSurCommande)?.nom
                                    )
                                }

                            </>
                        )
                    }
                </>
            )
        },
        {
            title: "Statut commande",
            dataIndex: "statutCommande",
            key: "statutCommande",
            editable: false,
            render: (_, record) => (
                <Tag color={getTagColor(record.statutCommande)}>
                    {record.statutCommande}
                </Tag>
            ),
        },
        {
            title: "Montant",
            dataIndex: 'montant',
            key: 'montant',
            render: (_, record) => (
                <>
                    {formatCurrency(record?.reglement?.montant)}
                </>
            )
        },
        {
            title: "Date de Commande",
            dataIndex: "dateEmission",
            key: "dateEmission",
            editable: false,
            render: (_, record) => <>{formatFrenchDate(record.dateEmission)}</>,
        },
    ];

    const isEditing = (record) => record.codeId === editingKey;
    console.log(selectedOrder)

    const [form] = Form.useForm();
    const expandedRowRender = (record) => (
        <div
            style={{
                padding: "16px",
                background: "#f9f9f9",
                display: "flex",
                justifyContent: "center",
                gap: "16px",
            }}
        >
            <Button
                type="default"
                style={{
                    backgroundColor: "#1a347d",
                    borderColor: "#4c757d",
                    color: "white",
                }}
                icon={<i className="bx bx-detail"></i>}
                onClick={() => {
                    setSelectedOrder(record);
                    navigate(`/commande/${record?.codeId}`)
                }}
            >
                Détails
            </Button>
        </div>
    );
    console.log(updateCommentaire)
    const validation = (lotA, updateCommentaire, reglementBonCommandeDTO) => {
        console.log("Code de la commande à valider :", lotA);
        const com = updateCommentaire
        console.log(updateCommentaire)
        setLoadingOrders(true)
        const validationBonCommandeDTO = {
            bonCommandeCodeId: lotA, commentaire: com, reglementBonCommandeDTO: reglementBonCommandeDTO
        }
        console.log(validationBonCommandeDTO)
        validateWithComment(validationBonCommandeDTO).then(r => {
            toast("Commande validée avec succès !");
            setModalVisible(false)
            setReload((prevState) => !prevState)
            setLoading(false)
        }).catch((error) => {
            console.error("Erreur lors de la validation :", error);
            toast("Erreur lors de la validation !");
            setLoadingOrders(false)
        });
    };


    const commandesReceptionnees = commandes.filter(
        (c) => c.statutCommande === "RECEPTIONNE" || c.statutCommande === "DELIVRE",
    );
    const autresCommandes = commandes.filter(
        (c) =>
            c.statutCommande !== "RECEPTIONNE" &&
            c.statutCommande !== "DELIVRE" &&
            c.statutCommande !== "REJETE",
    );

    return (
        <SinglePageLayout>

            <div className="content-wrapper">
                <div className="container-xxl flex-grow-1 container-p-y">
                    <>
                        <Button
                            type="primary"
                            icon={<PlusOutlined/>}
                            onClick={() => setOrderModalOpen(true)}
                        >
                            Initier une nouvelle commande
                        </Button>
                        <Tabs
                            defaultActiveKey="2"
                            style={{marginTop: 20}}
                            items={[
                                {
                                    label: "Commandes en  cours",
                                    key: "2",
                                    children: (
                                        <Spin spinning={loadingOrders}>
                                            <Form form={form} component={false}>
                                                <Table
                                                    columns={columns}
                                                    dataSource={autresCommandes}
                                                    rowKey="codeId"
                                                    expandable={{
                                                        expandedRowRender,
                                                    }}
                                                />
                                            </Form>
                                        </Spin>
                                    ),
                                },
                                {
                                    label: "Commandes Receptionnées",
                                    key: "1",
                                    children: (
                                        <Spin spinning={loadingOrders}>
                                            <Table
                                                columns={columns}
                                                dataSource={commandesReceptionnees}
                                                rowKey="codeId"
                                                expandable={{
                                                    expandedRowRender,
                                                }}
                                            />
                                        </Spin>
                                    ),
                                },
                            ]}
                        />
                        <PaymentConfirmationModal
                            visible={modalVisible}
                            onCancel={handleCancel}
                            onOk={validation}
                            lotA={lotA}
                            statutCommande={statutCommande}
                            typePaiement={typePaiement}
                        />
                    </>
                    <OrderModal orderModalOpen={orderModalOpen} setOrderModalOpen={setOrderModalOpen}
                                categories={categories}
                                onSubmitCommandeAttestation={
                                    onSubmitCommandeAttestation
                                }/>
                </div>

            </div>
        </SinglePageLayout>

    );
};

export default AgenceCommande;
